import React from "react";
import { Phone, MapPin, Clock } from "lucide-react";
import { useSiteSettings } from "@/context/SiteSettingsContext";

export default function Footer() {
  const { settings } = useSiteSettings();
  return (
    <footer data-testid="footer" className="border-t border-white/10 bg-black">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 py-12 grid gap-10 md:grid-cols-4">
        <div>
          <div className="flex items-center gap-2 mb-4">
            {settings.logo_url ? (
              <img src={settings.logo_url} alt={settings.brand_name} className="h-10 w-10 rounded-md object-cover border border-white/10"/>
            ) : (
              <div className="h-9 w-9 rounded-md bg-blue-600 flex items-center justify-center">
                <span className="font-display font-bold text-white text-lg">{(settings.brand_name || "P").slice(0, 1)}</span>
              </div>
            )}
            <span className="font-display font-semibold text-lg">{settings.brand_name}</span>
          </div>
          <p className="text-sm text-white/60 leading-relaxed">{settings.footer_tagline}</p>
        </div>

        <div>
          <p className="mono-label text-white/50 mb-3">Contact</p>
          <div className="space-y-2 text-sm text-white/80">
            <div className="flex items-start gap-2"><Phone className="h-4 w-4 mt-0.5 text-blue-400"/><span>{settings.business_phone}</span></div>
            <div className="flex items-start gap-2"><MapPin className="h-4 w-4 mt-0.5 text-blue-400"/><span>{settings.business_address}</span></div>
            <div className="flex items-start gap-2"><Clock className="h-4 w-4 mt-0.5 text-blue-400"/><span>{settings.business_hours}</span></div>
          </div>
        </div>

        <div>
          <p className="mono-label text-white/50 mb-3">Services</p>
          <ul className="space-y-1.5 text-sm text-white/70">
            <li>Screen Replacement</li>
            <li>Battery Replacement</li>
            <li>Charging Port Repair</li>
            <li>Water Damage Recovery</li>
            <li>Back Glass Replacement</li>
          </ul>
        </div>

        <div>
          <p className="mono-label text-white/50 mb-3">Shipping</p>
          <ul className="space-y-1.5 text-sm text-white/70">
            <li>Free shipping on all orders</li>
            <li>All-India delivery</li>
            <li>Dispatch within 48 hrs</li>
            <li>7-day replacement warranty</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 py-4 text-center text-xs text-white/40 font-mono">
        © {new Date().getFullYear()} {settings.brand_name} · All rights reserved
      </div>
    </footer>
  );
}
